<div *ngIf="currentLoad" [ngClass]="{'layout-column': isColumn, 'layout-row': !isColumn}"
     class="full-height full-width">

  <div class="flex layout-row layout-align-start-center"
       [ngClass]="{'margin-bottom-5': isColumn, 'margin-right-10': !isColumn}">
    <bringoz-icon iconName="weight" fill="#7E7E7E"></bringoz-icon>

    <div class="layout-row layout-align-start-center flex">
      <div class="progress flex layout-row margin-right-5">
        <div class="progress-bar" [ngClass]="{
                         'low': (currentLoad.weightLoadPercent < 50),
                         'mid': (currentLoad.weightLoadPercent >= 50 && currentLoad.weightLoadPercent) < 85,
                         'high': (currentLoad.weightLoadPercent >= 85)}" role="progressbar"
             [style.width.%]="currentLoad.weightLoadPercent || 0" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>

      <span class="value-indication br-caption-1 font-weight-500">{{currentLoad.weightLoadPercent | number:'1.0-0'}}%</span>

    </div>

  </div>

  <div class="flex layout-row layout-align-start-center"
       [ngClass]="{'margin-bottom-5': isColumn}">

    <bringoz-icon iconName="volume" fill="#7E7E7E"></bringoz-icon>

    <div class="flex layout-row layout-align-start-center">
      <div class="progress flex layout-row margin-right-5">
        <div class="progress-bar" [ngClass]="{
                         'low': (currentLoad.dimensionsLoadPercent < 50),
                         'mid': (currentLoad.dimensionsLoadPercent >= 50 && currentLoad.dimensionsLoadPercent) < 85,
                         'high': (currentLoad.dimensionsLoadPercent >= 85)}" role="progressbar"
             [style.width.%]="currentLoad.dimensionsLoadPercent || 0" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>

      <span class="value-indication br-caption-1 font-weight-500">{{currentLoad.dimensionsLoadPercent | number:'1.0-0'}}
        %</span>

    </div>

  </div>

  <div *ngIf="currentLoad.numberOfSpotsLoadPercent > -1"
       class="flex layout-row layout-align-start-center"
       [ngClass]="{'margin-left-10': !isColumn}">
    <bringoz-icon iconName="spot" fill="#7E7E7E"></bringoz-icon>

    <div class="layout-row layout-align-start-center flex">
      <div class="progress flex layout-row margin-right-5">
        <div class="progress-bar" [ngClass]="{
                         'low': (currentLoad.numberOfSpotsLoadPercent < 50),
                         'mid': (currentLoad.numberOfSpotsLoadPercent >= 50 && currentLoad.numberOfSpotsLoadPercent) < 85,
                         'high': (currentLoad.numberOfSpotsLoadPercent >= 85)}" role="progressbar"
             [style.width.%]="currentLoad.numberOfSpotsLoadPercent || 0" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>

      <span class="value-indication br-caption-1 font-weight-500">{{currentLoad.numberOfSpotsLoadPercent | number:'1.0-0'}}
        %</span>

    </div>

    <div class="layout-row layout-align-start-center flex">
      <div class="progress flex layout-row margin-right-5">
        <div class="progress-bar" [ngClass]="{
                         'low': (currentLoad.numberOfPalletsLoadPercent < 50),
                         'mid': (currentLoad.numberOfPalletsLoadPercent >= 50 && currentLoad.numberOfPalletsLoadPercent) < 85,
                         'high': (currentLoad.numberOfPalletsLoadPercent >= 85)}" role="progressbar"
             [style.width.%]="currentLoad.numberOfPalletsLoadPercent || 0" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>

      <span class="value-indication br-caption-1 font-weight-500">{{currentLoad.numberOfPalletsLoadPercent | number:'1.0-0'}}
        %</span>

    </div>

  </div>
</div>
